import React from 'react';
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import { Helmet } from "react-helmet";
import Logo from "../../../files/img/logo/logo.png";
import Title from "../elements/Title";
import { translate } from "../../../config/lang";
import { Styles } from "../../../config/design/styles";
import {CircularProgress} from "@mui/material";

// Applying styles with styled from Material-UI v6
const NotFoundDiv = styled('div')(({ theme }) => ({
    ...Styles.notFoundClass,
    textAlign: "center"
}));

function AppCardLoaderFields({ error, fvh,height }) {
    return (
        <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            style={{ height: fvh ? "100vh" : !!height ? height : 500, textAlign: "center" }}
        >
            <Grid item xs={12}>
                {error ? (
                    <>
                        <Helmet>
                            <title>{translate('error404')}</title>
                            <meta name='errorpage' content='true' />
                            <meta name='errortype' content='404 - Not Found' />
                            <meta name='prerender-status-code' content='404' />
                        </Helmet>
                        <NotFoundDiv>
                            <ListAltRoundedIcon />
                            <Title>{translate('error404')}</Title>
                            <Typography>{translate('error404Desc')}</Typography>
                        </NotFoundDiv>
                    </>
                ) : (
                    <CircularProgress/>
                )}
            </Grid>
        </Grid>
    );
}

export default AppCardLoaderFields;
